module.exports = __webpack_public_path__ + "img/21.709401cb.svg";